<template>
    <el-card class="fitness-index stored-value-card">
        <el-table
            border
            ref="tableData"
            v-if="tableData"
            :data="tableData"
            class="my-4"
            v-loading="loading"
            @row-click="clickRow"
            @selection-change="handleSelectChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="number" :label="$t('Common.number')" align="center" width="90"/>
            <el-table-column prop="name" :label="$t('Reception.First.card_name')" align="center"/>
            <el-table-column prop="validPeriod" :label="$t('Sell.Validity_period(days)')" align="center"/>
            <el-table-column prop="actualValue" :label="$t('Card.actual_value')" align="center" width="80px">
                <template slot-scope="{$index, row}">¥ {{ row.actualValue }}</template>
            </el-table-column>
            <el-table-column prop="basePrice" :label="$t('Sell.Basic_sell_price')" align="center" width="100px">
                <template slot-scope="{$index, row}">¥ {{ row.basePrice }}</template>
            </el-table-column>
            <el-table-column prop="transferFee" :label="$t('Reception.Fifth.transfer')" align="center" width="100px"/>
            <el-table-column prop="saleStatusName" :label="$t('Sell.Selling_status')" align="center" width="100px">
                <template slot-scope="{row}">
                    <span :class="row.saleStatus === 1 ? 'task-status' : 'del-status'">
                        {{ row.saleStatusName }}
                    </span>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="experienceCard" label="可在线购买" align="center" width="100px">
                <template slot-scope="{$index, row}">
                    {{ row.experienceCard === 1 ? $t('Common.yes') : $t('Common.no') }}
                </template>
            </el-table-column> -->
            <el-table-column prop="saleBegin" :label="$t('Fill.Start_time_sell')"  align="center" width="100px"/>
            <el-table-column prop="saleEnd" :label="$t('Fill.SaleEndTime')" align="center" width="100px"/>
            <el-table-column prop="sellStores" :label="$t('Sell.store')" align="center" width="110px"/>
            <el-table-column prop="supportStores" :label="$t('Sell.AdmissionStore')" align="center" width="110px"/>
            <el-table-column prop="remark" :label="$t('Common.remark')" align="center" width="110px"/>
        </el-table>
        <!-- 分页 -->
        <el-pagination
            v-if="tableData"
            class="text-right mt-5"
            @current-change="fetchData"
            :current-page.sync="pagination.page"
            :page-size="pagination.size"
            layout="total, prev, pager, next, jumper"
            :total="pagination.total"
        ></el-pagination>
        <!-- 新增/编辑弹窗 -->
        <stored-value-card-form
            ref="storedValueCardForm"
            :fetchData = "fetchData"
            :activeName="activeName"
            v-model="input"/>
        <!-- 付费团课 -->
        <team-lesson ref="teamLesson"/>
        <!-- 私教单次购买 -->
        <coach-lesson ref="coachLesson"/>
    </el-card>
</template>

<script>
import { Dialog, DatePicker, Row } from 'element-ui';
import StoredValueCardForm from '@/components/Dialog/Sell/StoredValueCardForm';
import TeamLesson from '@/components/Dialog/Sell/TeamLesson';
import CoachLesson from '@/components/Dialog/Sell/CoachLesson';

export default {
    props: ['activeName', 'stores', 'form', 'date'],
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
        ElRow: Row,
        StoredValueCardForm,
        TeamLesson,
        CoachLesson,
    },
    data() {
        return {
            input: '',
            storeCardForm: {},
            id: '',
            form_loading: false,
            record_visible: false,
            visible: false,
            loading: false,
            tableData: [],
            records: [],
            storedCardIds: [],
            supportTeamLesson: [],
            supportCoachLesson: [],
            rules: {
                cardNumber: [
                    {required: true, message: this.$t('Message.Member_card_number_noempty'), trigger: 'blur'},
                ],
                storeId: [
                    {required: true, message: this.$t('Message.choose_your_store'), trigger: 'blur'},
                ],
            },
            pagination: {
                size: 10,
                total: 0,
                page: 1,
            },
        };
    },
    computed: {},
    mounted() {},
    watch: {
        activeName(val) {
            if (val === 'storedValueCard') this.fetchData();
        },
        input(val) {
            if (val === 'update') this.fetchData();
        },
    },
    methods: {
        fetchData(page = null) {
            this.loading = true;
            if (page) this.pagination.page = page;
            API.get('stored-value-card/pages', {
                params: {
                    ...this.form,
                    ...this.pagination,
                    saleBegin: this.date && this.date.length ? this.date[0] : null,
                    saleEnd: this.date && this.date.length ? this.date[1] : null,
                },
            })
                .then(res => {
                    this.tableData = res.content;
                    this.pagination.total = res.totalElements;
                    const msg = `${this.$t('Charge.search')}：共${res.totalElements}条记录`;
                    this.$emit('input', msg);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleAdd() {
            if (!this.$$filterPermission('售卖-会籍卡/储值卡管理-添加、修改会籍卡/储值卡')) {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
                return;
            }
            this.$refs.storedValueCardForm.open();
        },
        handleEdit() {
            if (!this.$$filterPermission('售卖-会籍卡/储值卡管理-添加、修改会籍卡/储值卡')) {
                $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    callback: action => {},
                });
                return;
            }
            if (this.validSelect()) this.$refs.storedValueCardForm.open(this.storedCardIds[0]);
        },
        handleTeamLesson() {
            if (this.validSelect() && this.supportTeamLesson[0] === true) {
                if (this.$$filterPermission('售卖-会籍卡/储值卡管理-添加、修改会籍卡/储值卡'))
                    this.$refs.teamLesson.open(this.storedCardIds[0]);
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            } else if (this.validSelect()) {
                $ele.$alert(this.$t('Alert.course_tip'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                });
            }
        },
        handleCoachLesson() {
            if (this.validSelect() && this.supportCoachLesson[0] === true) {
                if (this.$$filterPermission('售卖-会籍卡/储值卡管理-添加、修改会籍卡/储值卡'))
                    this.$refs.coachLesson.open(this.storedCardIds[0]);
                else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            } else if (this.validSelect()) {
                $ele.$alert(this.$t('Alert.choose_setting'), this.$t('Message.tip_title'), {
                    confirmButtonText: this.$t('Message.confirm'),
                });
            }
        },
        handleForbidden() {
            if (this.validSelect()) {
                if (this.$$filterPermission('售卖-会籍卡/储值卡管理-添加、修改会籍卡/储值卡')) {
                    $ele.$confirm(this.$t('Message.Confirm_the_ban'), this.$t('Common.tip'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        cancelButtonText: this.$t('Common.cancel'),
                        type: 'warning',
                    }).then(() => {
                        API.delete(`stored-value-card/${this.storedCardIds[0]}/active`)
                            .then(() => {
                                $ele.$message.success(this.$t('Message.Successful_sale_ban'));
                                this.fetchData();
                            });
                    }).catch(() => {
                        $ele.$message.info(this.$t('Message.Cancelled'));
                    });
                } else {
                    $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                        confirmButtonText: this.$t('Message.confirm'),
                        callback: action => {},
                    });
                }
            }
        },
        handleRestore() {
            if (this.validSelect()) {
                $ele.$confirm(this.$t('Message.confirm_mershipcard'), this.$t('Common.tip'), {
                    confirmButtonText: this.$t('Message.confirm'),
                    cancelButtonText: this.$t('Common.cancel'),
                    type: 'warning',
                })
                .then(() => {
                    if (this.$$filterPermission('售卖-会籍卡/储值卡管理-添加、修改会籍卡/储值卡')) {
                        API.put(`stored-value-card/${this.storedCardIds[0]}/active`)
                        .then(() => {
                            $ele.$message.success(this.$t('Common.message.successRestore'));
                            this.fetchData();
                        });
                    } else {
                        $ele.$alert(this.$t('Message.no_permission'), this.$t('Message.tip_title'), {
                            confirmButtonText: this.$t('Message.confirm'),
                            callback: action => {},
                        });
                    }
                })
                .catch(() => {
                    $ele.$message.info(this.$t('Common.message.cancelRestore'));
                });
            }
        },
        handleSelectChange(val) {
            this.storedCardIds = val.map(el => el.id);
            this.supportTeamLesson = val.map(el => el.supportTeamLesson);
            this.supportCoachLesson = val.map(el => el.supportCoachLesson);
        },
        clickRow(row) {
            this.$refs.tableData.toggleRowSelection(row);
        },
        validSelect() {
            if (this.storedCardIds.length > 1) $ele.$message.warning(this.$t('Message.once_data'));
            else if (this.storedCardIds.length < 1) $ele.$message.warning(this.$t('Message.Please_select_a_data'));
            else return true;
        },
    },
};
</script>
<style lang="scss">
.stored-value-card {
    .icon {
        position: absolute !important;
        right: 0px;
        display: inline;
    }
    .title-3a {
        height: 20px;
        color: grey;
        line-height: 10px;
        font-size: 12px;
        font-weight: 400;
    }
    .task-status {
        color: #2a9546;
    }
    .del-status {
        color:#ce6969;
    }
}
</style>
